import { Injectable } from '@angular/core';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { ApiService } from '@shared/abstraction';
import { delay, Observable, of } from 'rxjs';
import {
  AnalyticReq,
  AuthorizedUsersCountSchema,
  BarChartSchema,
} from './analytics.abstraction';

@Injectable()
export class AnalyticsApiServiceMock extends ApiService {
  isLoading$ = this._isLoading$;

  getUsersCount(params: AnalyticReq): Observable<AuthorizedUsersCountSchema> {
    return of({ duringPeriod: 3, total: 3 }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }

  getChartCount(params: AnalyticReq): Observable<BarChartSchema> {
    return of({
      categories: ['Aug 1, 2024', 'Aug 2, 2024', 'Aug 3, 2024'],
      series: [
        {
          name: 'Users',
          data: [44, 55, 57],
        },
        {
          name: 'Stopped the bot',
          data: [30, 1, 19],
        },
      ],
    }).pipe(
      delay(1000),
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$)
    );
  }
}
